import React, { useEffect, useState } from "react";
import img1 from "../../../Assets/Slider/slider-bg1.jpg";
import img2 from "../../../Assets/Slider/slider-bg2.jpg";
import img3 from "../../../Assets/Slider/slider-bg3.jpg";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { Transition } from "@headlessui/react";
import "./HomeSlider.css";
const HomeSlider = () => {
  const slides = [
    {
      id: 1,
      image: img1,
      title: " Rahat Bin Omar Photography ",
      caption: " I Love to turn into beautiful things ",
    },
    {
      id: 2,
      title: " Rahat Bin Omar Photography ",
      image: img2,
      caption:
        "I specialize and landscape , advertorial and beautiful photography",
    },
    {
      id: 3,
      image: img3,
      title: " Rahat Bin Omar Photography ",
      caption: "for the best visulisation your company will",
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection("next");
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    if (index > currentSlide) {
      setDirection("next");
    } else {
      setDirection("prev");
    }
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setDirection("next");
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setDirection("prev");
    setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);
  };

  return (
    <div className="text-container">
      <div className="relative">
        <div className="overflow-hidden">
          <div className="flex">
            {slides.map((slide, index) => (
              <Transition
                key={slide.id}
                show={currentSlide === index}
                enter={`transform transition duration-1000 ease-out ${
                  direction === "next"
                    ? "translate-x-full"
                    : "-translate-x-full"
                }`}
                enterFrom={`transform ${
                  direction === "next"
                    ? "-translate-x-full"
                    : "translate-x-full"
                }`}
                enterTo="transform translate-x-0"
                leave="transform transition duration-1000 ease-out"
                leaveFrom="transform translate-x-0"
                leaveTo={`transform ${
                  direction === "next"
                    ? "-translate-x-full"
                    : "translate-x-full"
                }`}
              >
                <div className="flex-shrink-0 w-screen h-screen">
                  <img
                    src={slide.image}
                    alt=""
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute inset-0 bg-black opacity-30"></div>
                  <div className="absolute inset-0 p-8 flex flex-col justify-center">
                    <h1 className="text-3xl font-bold text-center  text-white mb-4">
                      {slide.title}
                    </h1>
                    <p className=" text-white text-center font-serif">
                      {slide.caption}
                    </p>
                  </div>
                </div>
              </Transition>
            ))}
          </div>
        </div>
        <div className="absolute top-1/2 left-0 transform -translate-y-1/2 flex items-center">
          <button
            className="text-white hover:text-gray-300 focus:outline-none"
            onClick={prevSlide}
          >
            <FaChevronCircleLeft className="h-8 w-8" />
          </button>
        </div>
        <div className="absolute top-1/2 right-0 transform -translate-y-1/2 flex items-center">
          <button
            className="text-white hover:text-gray-300 focus:outline-none"
            onClick={nextSlide}
          >
            <FaChevronCircleRight className="h-8 w-8" />
          </button>
        </div>
        <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-4">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              className={`h-2 w-2 mx-2 rounded-full ${
                index === currentSlide ? "bg-white" : "bg-gray-500"
              }`}
              onClick={() => goToSlide(index)}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};
export default HomeSlider;
